"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeStructureTypeFieldFiltering = void 0;
var StructureType_1 = require("../../types/SearchPage/StructureType");
var FromDeveloper_1 = require("../../constants/SearchPageCategories/FromDeveloper");
var StructureTypes_1 = require("../../constants/SearchPageCategories/StructureTypes");
var RoomWithPropertyAndStructureType_1 = require("../../constants/SearchPageCategories/RoomWithPropertyAndStructureType");
var RentalPriceTypes_1 = require("../../constants/SearchPageCategories/RentalPriceTypes");
var makeStructureTypeFieldFiltering = function (value, setStructureTypeQuery, isDeveloperQuery, propertyTypeQuery, replacePageURL, currentLanguage, deal, roomsQuery, rentalPrizeQuery) {
    setStructureTypeQuery(value);
    if (value === StructureType_1.STRUCTURE_TYPE.NEW_BUILDING) {
        if ((isDeveloperQuery === null || isDeveloperQuery === void 0 ? void 0 : isDeveloperQuery.length) &&
            (propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            !(roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length) &&
            !rentalPrizeQuery.length) {
            replacePageURL(FromDeveloper_1.DeveloperWithStructurePropertyType[currentLanguage][deal][propertyTypeQuery[0]]);
        }
        if (!(isDeveloperQuery === null || isDeveloperQuery === void 0 ? void 0 : isDeveloperQuery.length) &&
            (propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            !(roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length) &&
            !rentalPrizeQuery.length) {
            replacePageURL(StructureTypes_1.STRUCTURE_TYPES[currentLanguage][deal][propertyTypeQuery[0]]);
        }
        if (!(isDeveloperQuery === null || isDeveloperQuery === void 0 ? void 0 : isDeveloperQuery.length) &&
            (propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            (roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length) &&
            !rentalPrizeQuery.length) {
            replacePageURL(RoomWithPropertyAndStructureType_1.RoomWithPropertyAndStructureType[currentLanguage][deal][propertyTypeQuery[0]][roomsQuery[0]]);
        }
        if (!(isDeveloperQuery === null || isDeveloperQuery === void 0 ? void 0 : isDeveloperQuery.length) &&
            (propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            !(roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length) &&
            rentalPrizeQuery.length) {
            replacePageURL(RentalPriceTypes_1.RentalPriceTypes[currentLanguage].rent
                .WITH_PROPERTY_STRUCTURE_TYPE[propertyTypeQuery[0]]);
        }
        if (!(isDeveloperQuery === null || isDeveloperQuery === void 0 ? void 0 : isDeveloperQuery.length) &&
            (propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            (roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length) &&
            rentalPrizeQuery.length) {
            replacePageURL(RentalPriceTypes_1.RentalPriceTypes[currentLanguage].rent
                .WITH_ROOM_PROPERTY_STRUCTURE_TYPE[propertyTypeQuery[0]][roomsQuery[0]]);
        }
    }
};
exports.makeStructureTypeFieldFiltering = makeStructureTypeFieldFiltering;
